import * as z from 'zod';
const uaePhoneNumberRegex =
  /^(?:\+971\s?5[0-9]{1}\s?[0-9]{3}\s?[0-9]{4}|05[0-9]{1}\s?[0-9]{3}\s?[0-9]{4})$/;

export const ksaBookingSchema = z.object({
  customerName: z.string().min(1, "Name is required"),
  phone: z
    .string()
    .regex(
      uaePhoneNumberRegex,
      "Phone number must be a valid UAE mobile number (e.g., +971 50 123 4567 or 050 123 4567)"
    ),
  email: z.string().email("Invalid email"),
  // Adding new fields
  adultsNumber: z
    .number({ invalid_type_error: "Adults number must be a number" })
    .min(1, "Adults number must be at least 1")
    .max(9, "Adults number cannot exceed 9"),

  childrenNumber: z
    .number({ invalid_type_error: "Children number must be a number" })
    .min(0, "Children number cannot be less than 0")
    .max(9, "Children number cannot exceed 9"),
  isGccResident: z.boolean(),
  serviceId: z.string().uuid("Invalid service ID format").optional(),
  totalPrice: z.number().nullable().optional(),
  nationalityId: z
    .string({ required_error: "Nationality is required" })
    .uuid("Invalid nationality ID format")
    .optional()
    .refine((val) => val !== undefined, {
      message: "Nationality is required",
    }),

      // 🆕 Add these fields
  checkInDate: z.date(),
  checkOutDate: z.date(),
  checkInTime: z.string(),
  checkOutTime: z.string(),
});

export type KsaBookingFormSchema = z.infer<typeof ksaBookingSchema>;
